import { t } from '@lingui/core/macro';
import { ChipAction, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { SearchAggregationMetricType, } from 'shared/domains/apollo/generated/types';
import { ChipDropdown } from 'shared/domains/common-ui';
import { getMetricTypeTranslations, allowedPropertiesTranslations } from './translations';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function MetricInput(props) {
    const { pathBase, remove } = props;
    const currentPath = `${pathBase}.metricInput`;
    const [field, , helpers] = useField(currentPath);
    const handleChangeType = (val) => {
        helpers.setValue(Object.assign(Object.assign({}, field.value), { type: val }));
    };
    return (<FieldInputContainer>
      <SelectDataPoint label={t({ message: 'Metric', comment: 'Insights widget form: Metric field' })} selectedValue={allowedPropertiesTranslations(field.value.field)} name={pathBase} action={<ChipAction onClick={remove}>
            <Falcon icon="close"/>
          </ChipAction>}/>

      <ChipDropdown label={t({ message: 'Config', comment: 'Insights: Metric configuration' })} secondary={getMetricTypeTranslations(field.value.type)} appearance="secondary" variant="outline">
        {Object.values(SearchAggregationMetricType).map((val) => (<Menu.ItemRadio key={val} onChange={() => handleChangeType(val)} checked={val === field.value.type}>
            {getMetricTypeTranslations(val)}
          </Menu.ItemRadio>))}
      </ChipDropdown>
    </FieldInputContainer>);
}
